// extracted by mini-css-extract-plugin
module.exports = {"icon":"Link_icon__Z3cYw"};